import LabelTextEditor from './LabelTextEditor';

export default LabelTextEditor;